import { useSearchParams } from "react-router-dom";
import { useEffect } from "react";
import { Config } from "../.env.js";

const InternalGuard = ({ children }) => {
  const [searchParams] = useSearchParams();
  const secretToken = process.env.REACT_APP_INTERNAL_SECRET; // ✅ works only in CRA

  useEffect(() => {
    const token = searchParams.get("token");

    if (!token || token !== secretToken) {
      // Hard navigation to the marketing root so the real index.html home
      // page loads. A react-router navigate("/") stays inside this SPA,
      // which has no "/" route and would render NotFound instead.
      window.location.replace(`${Config.SITE_URL}/`);
    }
  }, [searchParams, secretToken]);

  return children;
};

export default InternalGuard;
